import Parse from "parse";
import { TicketData, TicketTypedMetaField } from "..";
import { Ticket_FormConfig } from "../../../../js/parsegenerated";
import { TicketMetaFieldConfig } from "../../../administration";
import { SaveConfigManager } from "../../creation";
import { TicketMetaFormField } from "../types/TicketMeta";

export function useTicketMeta(ticketData: TicketData) {
  const meta = ticketData?.ticket?.get("meta")?.fields;
  if (!meta) return [];
  return meta as TicketTypedMetaField[];
}

/**
 *  Converts the meta fields to a form field object
 *  This is used to convert the meta fields to a form field object that can be used in the form
 * @param meta the meta data fields to convert
 * @returns  returns a form field object with the meta fields as keys and their values
 */
export async function splitMetaToFormFields(
  meta: TicketTypedMetaField[]
): Promise<TicketMetaFormField> {
  if (!meta) return {};

  const metaFields: TicketMetaFormField = {};
  for (const field of meta) {
    if (field.value === undefined || field.value === null) continue;
    metaFields[field.name] = field.value;
  }

  return metaFields;
}

export async function combineMetaWithConfig(
  meta: TicketMetaFormField
): Promise<TicketTypedMetaField[]> {
  if (!meta) return [];

  const configManager = new SaveConfigManager(
    await new Parse.Query(Ticket_FormConfig).first()
  );
  const metaConfig = configManager?.getFieldConfig("meta");

  if (!metaConfig || !configManager) return [];

  const metaTyped: TicketTypedMetaField[] = [];
  for (const metaName in meta) {
    const metaValue = meta[metaName];
    const valueTyped = getMetaValueTyped(metaName, metaValue, metaConfig);
    metaTyped.push(valueTyped as TicketTypedMetaField);
  }

  return metaTyped.filter(Boolean) as TicketTypedMetaField[];
}

/**
 * Converts the meta value to a typed value based on the field config
 * @param metaName
 * @param metaValue
 * @param config
 * @returns the field config with the value set to the meta value
 */
function getMetaValueTyped(
  metaName: string,
  metaValue: TicketMetaFormField[number],
  config: TicketMetaFieldConfig
) {
  const field = config.fields?.find((field) => field.name === metaName);
  if (!field) return undefined; // this is the case when meta is set in the ticket but the user has no access to the form config

  return {
    ...field,
    value: metaValue,
  };
}
